import {SecureService} from "@/services/superclasses/secure-service";
import {FormResponse} from "@/interfaces/form-response";
import {WatchListVatinManage} from "@/interfaces/watch-list-vatin-manage";

const api = window.contextPath + '/rest/watch-lists';

export class WatchListVatinSecureService extends SecureService {

    public create = async (watchListId: number, data: WatchListVatinManage): Promise<FormResponse<void>> => {
        return this.data(await this.post<FormResponse<void>>(api + "/" + watchListId + "/vatins", data))
    }

    public remove = async (watchListId: number, vatin: string): Promise<void> => {
        return this.data(await this.delete(api + "/" + watchListId + "/vatins/" + vatin));
    }

    public getByWatchListId = async (watchListId: number, vatin: string): Promise<void> => {
        return this.data(await this.get<void>(api + "/" + watchListId + "/" + vatin));
    }
}

export const watchListVatinSecureService = new WatchListVatinSecureService()